import React, { useState } from 'react';
import styled from 'styled-components';

import { WindowDropDowns } from 'components';
import dropDownData from './dropDownData';

export default function Notepad({ onClose }) {
  var text = `


     .. @ :..  ......                
.....-##+--#%%@######%%%*. .          YisusNotChrist@Workstation
..  .@#################%@@%# .    .   -------------------------
    #%#####################@%#        OS: Windows XP
    %#####################%@%##..     Kernel: 3D-Artist-Core-v1.0
 ..##%#####################%%%##: .   Uptime: 14 hours (Rendering...)
  #####%%%%%@@%###***######%@####.    Packages: Maya, Blender, Sandias
.=#####%%  -..  . :=:+@###%%#####=    Resolution: 3840x2160 (Dual Monitor)
.=###%###:-.:@ ..=@:-:.%#@.-######    Profession: Modelador 3D
.=#*##*##::.  .  .:-:---:.########    Specialty: Hard Surface & Sculpting
.=*******=.. ....  :--%+=+%##****=    facebook: facebook.com/jesus.aaron.50
 .*******@=##++-**%#++#==++@##***. 
  .*****# .:%==.+-.%=+...-=##***:. 
   .****# ... .%   .=.. -#+@#**..  
. .  +***::=@===%*:.::%++++###   . 
     . +****============+++#-- ... 
...      .+#===========++++@--... .
..    .   %%%%%%%%%%%%%%%%%#-:
`;

  const [docText, setDocText] = useState(
    `
 /$$     /$$ /$$                                     /$$   /$$             /$$            /$$$$$$  /$$                 /$$             /$$    
|  $$   /$$/|__/                                    | $$$ | $$            | $$           /$$__  $$| $$                |__/            | $$    
 \\  $$ /$$/  /$$  /$$$$$$$ /$$   /$$  /$$$$$$$      | $$$$| $$  /$$$$$$  /$$$$$$        | $$  __/| $$$$$$$   /$$$$$$  /$$  /$$$$$$$ /$$$$$$   
  \\  $$$$/  | $$ /$$_____/| $$  | $$ /$$_____/      | $$ $$ $$ /$$__  $$|_  $$_/        | $$      | $$__  $$ /$$__  $$| $$ /$$_____/|_  $$_/  
   \\  $$/   | $$|  $$$$$$ | $$  | $$|  $$$$$$       | $$  $$$$| $$  \\ $$  | $$          | $$      | $$  \\ $$| $$  \\__/| $$|  $$$$$$   | $$    
    | $$    | $$ \\____  $$| $$  | $$ \\____  $$      | $$\\  $$$| $$  | $$  | $$ /$$      | $$    $$| $$  | $$| $$      | $$ \\____  $$  | $$ /$$
    | $$    | $$ /$$$$$$$/|  $$$$$$/ /$$$$$$$/      | $$ \\  $$|  $$$$$$/  |  $$$$/      |  $$$$$$/| $$  | $$| $$      | $$ /$$$$$$$/  |  $$$$/
    |__/    |__/|_______/  \\______/ |_______/       |__/  \\__/ \\______/    \\___/         \\______/ |__/  |__/|__/      |__/|_______/    \\___/  
    ` + text,
  );
  const [wordWrap, setWordWrap] = useState(false);
  function onClickOptionItem(item) {
    switch (item) {
      case 'Exit':
        onClose();
        break;
      case 'Word Wrap':
        setWordWrap(!wordWrap);
        break;
      case 'Time/Date':
        const date = new Date();
        setDocText(
          `${docText}${date.toLocaleTimeString()} ${date.toLocaleDateString()}`,
        );
        break;
      default:
    }
  }
  function onTextAreaKeyDown(e) {
    // handle tabs in text area
    if (e.which === 9) {
      e.preventDefault();
      e.persist();
      var start = e.target.selectionStart;
      var end = e.target.selectionEnd;
      setDocText(`${docText.substring(0, start)}\t${docText.substring(end)}`);

      requestAnimationFrame(() => {
        e.target.selectionStart = start + 1;
        e.target.selectionEnd = start + 1;
      });
    }
  }

  return (
    <Div>
      <section className="np__toolbar">
        <WindowDropDowns items={dropDownData} onClickItem={onClickOptionItem} />
      </section>
      <StyledTextarea
        wordWrap={wordWrap}
        value={docText}
        onChange={e => setDocText(e.target.value)}
        onKeyDown={onTextAreaKeyDown}
        spellCheck={false}
      />
    </Div>
  );
}

const Div = styled.div`
  height: 100%;
  background: linear-gradient(to right, #edede5 0%, #ede8cd 100%);
  display: flex;
  flex-direction: column;
  align-items: stretch;
  .np__toolbar {
    position: relative;
    height: 21px;
    flex-shrink: 0;
    border-bottom: 1px solid white;
  }
`;

const StyledTextarea = styled.textarea`
  flex: auto;
  outline: none;
  font-family: 'Lucida Console', monospace;
  font-size: 13px;
  line-height: 14px;
  resize: none;
  padding: 2px;
  ${props => (props.wordWrap ? '' : 'white-space: nowrap; overflow-x: scroll;')}
  overflow-y: scroll;
  border: 1px solid #96abff;
`;
